import React from "react";

const QuieresEmpezar = () => {
    return (
        <section className='w-full bg-bgBlack py-16 px-6 flex flex-col items-center text-center'>
            <h2 className='text-3xl lg:text-4xl font-black uppercase'>¿Quieres empezar?</h2>

            <p className='mt-4 text-white/70 max-w-md'>Cuéntame tu situación y qué quieres conseguir.</p>
            <p className='mt-2 text-white/70 max-w-md'>Revisaré tu caso para valorar qué opción se adapta mejor a ti.</p>

            <p className='mt-8 text-xs uppercase tracking-widest text-white/50 font-bold'>Plazas limitadas cada mes</p>
            <p className='mt-2 text-sm text-white/50 max-w-md'>Cuando se completa el número de plazas disponibles, las nuevas incorporaciones pasan al siguiente periodo.</p>

            <a href='#cambio'
               className='mt-8 w-full max-w-[280px] py-4 px-6 bg-sbPallet-accent hover:bg-white hover:text-sbPallet-accent rounded-lg text-lg font-bold uppercase flex items-center justify-center ease-in duration-100'>
                Reservar mi plaza
            </a>
        </section>
    )
}

export default QuieresEmpezar
